// @flow
import {graphql} from 'react-relay'

import type {ID} from './types'
import createMutationPromise from './createMutationPromise'

const mutation = graphql`
  mutation DeleteProposalChangeMutation(
    $input: DeleteProposalChangeInput!
  ) {
    deleteProposalChange(input: $input) {
      deletedChangeId

      proposal {
        ...EditorFooter_proposal
        ...ProposeNowButton_proposal
      }
    }
  }
`

type Input = {
  changeId: ID,
  meetingId: ?ID,
}

export default ({changeId, meetingId}: Input): Promise<mixed> => {
  const variables = {
    input: {
      changeId,
      meetingId,
    },
  }

  const optimisticResponse = {
    deleteProposalChange: {
      deletedChangeId: changeId,
    },
  }

  const configs = [{
    type: 'NODE_DELETE',
    deletedIDFieldName: 'deletedChangeId',
  }]

  return createMutationPromise({
    mutation,
    variables,
    configs,
    optimisticResponse,
  })
}
